import React, { useState } from 'react';
import { Card } from 'antd';
import { CargoItemsTable } from 'components/cargos/cargo-items-table';
import { CargoTripsTable } from 'components/cargos/cargo-trips-table';
import { DocumentsList } from 'components/documents/documents-list';
import { DocumentsUpload } from 'components/documents/documents-upload';
import { ECargoMainTab, type ICargoMainProps } from './types';

export const CargoMain: React.FC<ICargoMainProps> = (props) => {
  const { cargoId, cargoType } = props;
  const [activeTabKey, setActiveTabKey] = useState<ECargoMainTab>(ECargoMainTab.items);

  const onTabChange = (key: string) => {
    setActiveTabKey(key as ECargoMainTab);
  };

  const tabListNoTitle = [
    {
      key: ECargoMainTab.items,
      label: 'Items',
    },
    {
      key: ECargoMainTab.documents,
      label: 'Documents',
    },

    {
      key: ECargoMainTab.trips,
      label: 'Trips',
    },
  ];

  const contentListNoTitle: Record<ECargoMainTab, React.ReactNode> = {
    [ECargoMainTab.items]: <CargoItemsTable cargoId={cargoId} cargoType={cargoType} />,
    [ECargoMainTab.documents]: (
      <>
        <DocumentsUpload cargoId={cargoId} />
        <DocumentsList cargoId={cargoId} />
      </>
    ),
    [ECargoMainTab.trips]: <CargoTripsTable cargoId={cargoId} />,
  };

  return (
    <Card style={{ width: '100%' }} tabList={tabListNoTitle} activeTabKey={activeTabKey} onTabChange={onTabChange}>
      {contentListNoTitle[activeTabKey]}
    </Card>
  );
};
